export const iconFontAwesomeArrowsCloudArrowUp = (
	<i className="fa-solid fa-cloud-arrow-up"></i>
);
